import React from 'react'
import classNames from 'classnames'

import getLabels from '../../utils/getLabels'

import LoadingIcon from '../LoadingIcon'
import ChangesDisclaimer from '../ChangesDisclaimer'

const SeatTradeTradesOverview = ({
  classes,
  tourOperator,
  flights,
  departureAirportName,
  arrivalAirportName,
  seatsAreBeingTraded,
  disclaimerText,
}) => {
  return (
    <section
      className={classNames(classes.resize, {
        [classes.wrapper]: !seatsAreBeingTraded,
        [classes.wrapperWithLoadingIcon]: seatsAreBeingTraded,
      })}
    >
      {seatsAreBeingTraded ? (
        <LoadingIcon className={classes.loadingIndicator} />
      ) : (
        <React.Fragment>
          <header className={classes.header}>
            <h1 className={classes.title}>{getLabels('trade_seats_with')}</h1>
            <h2 className={classes.title}>{tourOperator}</h2>
          </header>
          <ChangesDisclaimer disclaimer={disclaimerText} />
          <article className={classes.content}>
            <div className={classes.flightRoute}>
              {departureAirportName} - {arrivalAirportName}
            </div>
            <div className={classNames(classes.row, classes.rowHeader)}>
              <h4>{getLabels('flight')}</h4>
              <h4>{getLabels('day')}</h4>
              <h4>{getLabels('departure_date')}</h4>
              <h4>{getLabels('time')}</h4>
              <h4>{getLabels('seats')}</h4>
            </div>
            {flights.map(flight => {
              return (
                <div
                  className={classes.row}
                  key={`${flight.date}-${flight.number}`}
                >
                  <div className={classes.flightInformation}>
                    <div>{flight.number}</div>
                    <div>{flight.day}</div>
                    <div>{flight.date}</div>
                    <div>{flight.time}</div>
                  </div>
                  <div>{flight.seats}</div>
                </div>
              )
            })}
          </article>
        </React.Fragment>
      )}
    </section>
  )
}

export default SeatTradeTradesOverview
